export enum ReportScheduleDialogParameterFieldTypeEnum {
    NumberParameter = 0,
    CurrencyParameter = 1,
    BooleanParameter = 2,
    DateParameter = 3,
    StringParameter = 4,
    DateTimeParameter = 5,
    TimeParameter = 6,

    DropdownParameter = 100
}
